import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { Observable } from 'rxjs';

@Injectable()
export class httpTokenInterceptorService implements HttpInterceptor {

    constructor(
        private authenticationService: AuthenticationService
    ) {

    }

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.authenticationService.token) {
            request = request.clone({
                setHeaders: { Authorization: `Bearer ${this.authenticationService.token}` }
            });
        }

        return next.handle(request);
    }
}